import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-invitation-codes',
  templateUrl: './invitation-codes.component.html',
  styleUrls: ['./invitation-codes.component.css']
})
export class InvitationCodesComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/beta-codes/invitation-codes/invitation-codes.component.ts